import { render, staticRenderFns } from "./PanicBuying.vue?vue&type=template&id=028cc265&scoped=true&"
import script from "./PanicBuying.vue?vue&type=script&lang=js&"
export * from "./PanicBuying.vue?vue&type=script&lang=js&"
import style0 from "./PanicBuying.vue?vue&type=style&index=0&id=028cc265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028cc265",
  null
  
)

export default component.exports